import { defineMessage } from 'services/localization';

export const messages = {
    lockDateOverrideWarning: defineMessage('when_approved_the_date__ate_is_set_for_lockdate'),
    matchingPolicyViolationNotMatchedToAnyPurchaseOrder: defineMessage(
        'bill_cant_be_approved_s_d_to_any_purchase_order'
    ),
    matchingPolicyViolationMatchedNotAllItems: defineMessage('bill_cant_be_approved_s_t_all_items_are_matched'),
};
